// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__F5qv4","productName":"Table_productName__38nxh"};